

















import Vue from "vue";
import Component from "vue-class-component";
import { Model } from "vue-property-decorator";
import { focusNext } from "@/lib/formHelpers";
import { $t } from "@/lib/i18nHelpers";
import { FormField, FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import BaseInput from "@/components/BaseInput";
import PaymentSystemLogo from "../PaymentSystemLogo";

@Component({ name: "CardDetailsForm", components: { PaymentSystemLogo, BaseInput, BaseForm } })
export default class CardDetailsForm extends Vue {
  @Model("input", { required: true })
  public readonly values!: FormValues;

  public fields: FormFields = [
    {
      name: "cardNumber",
      label: $t("Card number"),
      placeholder: $t("Card number"),
      fieldClass: "inline-field",
      prependIcon: "sci-credit-card-outline",
      prependIconColor: "var(--palette-gray)",
      pattern: "\\d*",
      type: "tel",
      rules: ["required", "credit_card"],
      maxlength: "16",
      hideErrorMessage: true,
      hideLabel: true,
    },
    {
      name: "expireDate",
      label: $t("Expire date"),
      placeholder: "MM/YY",
      fieldClass: "inline-field px-0",
      pattern: "\\d*",
      type: "tel",
      rules: ["required", "credit_card_expire"],
      maskOpts: {
        showMaskOnFocus: false,
        showMaskOnHover: false,
        regex: "\\d{2}/\\d{2}",
      },
      hideErrorMessage: true,
      hideLabel: true,
    },
    {
      name: "cvc",
      label: $t("CVC"),
      placeholder: "CVC",
      fieldClass: "inline-field",
      pattern: "\\d*",
      type: "tel",
      rules: ["required", "max:4", "min:3", "numeric"],
      hideErrorMessage: true,
      hideLabel: true,
    },
    {
      name: "nameOnCard",
      label: $t("Name on card"),
      rules: ["required", "alpha_spaces"],
      hideErrorMessage: true,
    },
  ];

  public onFormInput(v: FormValues, e: InputEvent, field: FormField) {
    const target = e.target as HTMLInputElement;
    if (
      (field.name === "cardNumber" && target.value.length === 16) ||
      (field.name === "expireDate" && target.value.replace(/\/|_/g, "").length === 4) ||
      (field.name === "cvc" && target.value.length === 4)
    ) {
      focusNext(target.value, target);
    }
    this.$emit("input", v);
  }

  public getFirstErrorMessage(errors: Record<string, string[]>) {
    const error = Object.entries(errors).find(error => error[1].length > 0);
    return error ? error[1][0] : "";
  }
}
